import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
  <p>
    Any levy liability estimate or estimate of the component levy amounts on which the levy liability estimate is based
    is provided for indicative purposes only. No claim or representation is made as to the final levy liability in
    respect of a parcel of land. An estimate is not an invoice. Information concerning the levy liability estimate and
    component levy amounts should not be relied on for any purpose other than to provide an indicative estimate of the
    levy liability and component levy amounts that might apply to a parcel of land at the time of the issue of the
    information only. Parcel boundaries, levy rates and component levy amounts shown may be subject to change. The
    estimate of a levy liability and extent of component levy amounts for a parcel of land produced by MSA Levy Estimator may
    be incomplete in some cases (for example, a land parcel’s levy liability may already have been partially or fully
    met).
  </p>
  <p>
    This page may be of assistance to you for indicative purposes, however the State of Victoria and its employees and
    officers do not guarantee that the page is complete, without flaw or is wholly appropriate for your particular
    purposes and therefore disclaims all liability for any error, loss or other consequence which may arise from you
    relying on any information on this page.
  </p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      